import styled from 'styled-components';

const StyledCertificateUploadButton = styled.div`
   margin-top: 24px;
`;
StyledCertificateUploadButton.displayName = 'StyledCertificateUploadButton';

export { StyledCertificateUploadButton };
